// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"text\" on-select=\"parent.updateTextboxColor(color)\"> </toolbar-color-menu> ";
// Exports
module.exports = code;